import { Navigate } from "react-router-dom";
import { useRecoilValue, atom } from "recoil";
import PropTypes from 'prop-types';
import { isDebug } from "../utils";

export const userInfo = atom({
    key: 'userInfo',
    default: {
        userId: '',
        userName: '',
        userType: 'basic',
    },
});

AuthProvider.propsTypes = {
    children: PropTypes.node.isRequired,
};

export default function AuthProvider({children}) {
    const auth = useRecoilValue(userInfo);
    if (isDebug()) console.log("## AuthProvider auth", new Date().toISOString(), auth);
    return auth.userId.length > 0 ? children : <Navigate to="/login" replace />;
};